module.exports = react-dom;


//////////////////
// WEBPACK FOOTER
// external "react-dom"
// module id = 105
// module chunks = 0